import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M15.5 19a.497.497 0 0 1-.239-.061L10 16.07l-5.261 2.869c-.168.092-.373.079-.529-.032s-.235-.301-.203-.49l.958-5.746-3.818-3.818c-.132-.132-.18-.328-.123-.506s.209-.31.394-.341l5.749-.958 2.386-4.772C9.638 2.107 9.811 2 10 2s.363.107.447.276l2.386 4.772 5.749.958c.185.031.337.162.394.341s.01.374-.123.506l-3.818 3.818.958 5.746a.5027.5027 0 0 1-.203.49.5027.5027 0 0 1-.29.093z',
  ],
  height: 20,
  width: 20,
});
